import React from "react";
import "../styles/Home.css";

function Home() {
  return (
    <div className="home">
      <h1>主页</h1>
      <footer className="footer">Sendonet ©2025</footer>
    </div>
  );
}

export default Home;
